import { css } from '@emotion/css';
import { bp } from '../../theme/theme';

export const root = css({
  backgroundImage: 'url("/images/poster/contacts_bg.jpg")',
  backgroundPosition: "center",
  [bp.lg]: {
    backgroundImage: 'url("/images/poster/contacts_bg.jpg")',
  }
});